import type { TransferHoursData } from './types'
import api from '.'

export async function getTransferHours(): Promise<TransferHoursData> {
  const res = await api.get<TransferHoursData>('/transfer-hours')
  return res.data
}

export interface TransferHourPayload {
  day: number
  start: string
  end: string
  enabled: boolean
}

export async function saveTransferHours(
  hours: TransferHourPayload[],
): Promise<void> {
  await api.post('/transfer-hours', { hours })
}
